export default __webpack_public_path__ + "static/media/notification-alert.e7d17b5b.svg";